module.exports = {
  methods: {
    redirectTo404: async function () {
      await this.$router.push({
        name: "page-not-found",
        // preserve current path and remove the first char to avoid the target URL starting with `//`
        params: { pathMatch: this.$route.path.substring(1).split("/") },
        // preserve existing query and hash if any
        query: this.$route.query,
        hash: this.$route.hash,
      });
    },
  },
};
